import styled, { css } from "styled-components";
import { ButtonState } from ".";

const shared = css<{ state: ButtonState; destructiveAction: boolean }>`
  cursor: pointer;
  border: ${({ theme, destructiveAction }) =>
    `${theme.deprecatedBorder.weight.heavy} solid ${
      destructiveAction ? theme.deprecatedColors.error : theme.deprecatedColors.primary.normal
    }`};
  border-radius: ${({ theme }) => theme.deprecatedBorder.radius.normal};
  background-color: ${({ theme, state, destructiveAction }) => {
    const darkColor = destructiveAction
      ? theme.deprecatedColors.error
      : theme.deprecatedColors.primary.extraDark;
    const color = destructiveAction
      ? theme.deprecatedColors.error
      : theme.deprecatedColors.primary.normal;
    return state === "pressed"
      ? darkColor
      : state === "hover"
      ? color
      : theme.deprecatedColors.white;
  }};
  color: ${({ theme, state, destructiveAction }) =>
    state === "none"
      ? destructiveAction
        ? theme.deprecatedColors.error
        : theme.deprecatedColors.primary.normal
      : theme.deprecatedColors.text.light};
  padding: ${({ theme }) => theme.deprecatedSpacing.component.three};
  padding-left: ${({ theme }) => theme.deprecatedSpacing.component.four};
  padding-right: ${({ theme }) => theme.deprecatedSpacing.component.four};

  font-weight: ${({ theme }) => theme.font.weight.normal};
  font-size: ${({ theme }) => theme.font.size.body.two};
  text-transform: uppercase;
  text-decoration: none;
  &:disabled {
    background-color: ${({ theme }) => theme.deprecatedColors.gray.seven};
    cursor: not-allowed;
    border: none;
  }
`;

export const button = styled.button<{ state: ButtonState; destructiveAction: boolean }>`
  ${shared}
`;

export const a = styled.a<{ state: ButtonState; href: string; destructiveAction: boolean }>`
  ${shared}
`;
